<form-builder-form-builder-report [formTypeId]="formId"></form-builder-form-builder-report>